import React from "react";
import "./Messages.scss";
import { formatTimeOfDay, getDateLabel, shouldShowDateLabel } from "../../../helpers/utilities";

const Messages = ({ messages }) => {
    return (
        <div className="messages-container">
            {messages?.map((message, index) => {
                const previousMessage = index > 0 ? messages[index - 1] : null;
                const showDateLabel = shouldShowDateLabel(message, previousMessage);
                
                return (
                    <React.Fragment key={message.id}>
                        {showDateLabel && (
                            <div className="date-separator">
                                <span className="date-label">{getDateLabel(message.created_at)}</span>
                            </div>
                        )}
                        <div className={`message-wrapper ${message.sender ? 'sent' : 'received'}`}>
                            <div className={`message-container ${message.sender ? 'sent' : 'received'}`}>
                                <p className="message-text">{message.text}</p>
                            </div>
                            <span className="message-timestamp">{formatTimeOfDay(message.created_at)}</span>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    )
};

export default Messages;    